import LockIcon from "@mui/icons-material/Lock";
import PublicIcon from "@mui/icons-material/Public";
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Typography,
} from "@mui/material";

import { useFieldContext } from "components/Forms/AppForm";

import { EcrFile } from "../EcrCommentForm";

interface EcrFileCardProps {
  file: EcrFile;
  index: number;
}

const EcrFileCard = ({ file, index }: EcrFileCardProps) => {
  const field = useFieldContext<EcrFile[]>();

  const handleRemove = () => {
    field.removeValue(index);
  };

  const Avatar =
    file.documentVisibility === "Proprietary" ? LockIcon : PublicIcon;
  const avatarColor =
    file.documentVisibility === "Proprietary" ? "error" : "success";
  return (
    <Card sx={{ width: "250px", display: "flex", flexDirection: "column" }}>
      <CardHeader
        title={file.fileLabel}
        sx={{
          background: "whitesmoke",
          ".MuiCardHeader-avatar": {},
        }}
        subheader={"ECR Comment"}
        avatar={
          <Avatar
            sx={{
              alignSelf: "flex-start",
            }}
            fontSize="small"
            color={avatarColor}
          />
        }
        slotProps={{
          title: {
            fontSize: 18,
          },
          subheader: {
            fontSize: 14,
          },
        }}
      />

      <CardContent
        sx={{
          display: "flex",
          flex: 1,
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",

          padding: 1,
          "&.MuiCardContent-root:last-child": {
            paddingBottom: 1,
          },
        }}
      >
        <Typography
          fontSize={16}
          paddingX={1}
          textAlign="left"
          sx={{
            wordBreak: "break-word",
          }}
          align="center"
        >
          {file.file.name}
        </Typography>
      </CardContent>

      <CardActions sx={{ justifyContent: "flex-end" }}>
        <Button
          variant="outlined"
          color="error"
          fullWidth
          size="small"
          onClick={handleRemove}
        >
          Remove
        </Button>
      </CardActions>
    </Card>
  );
};
export default EcrFileCard;
